module.exports = __webpack_public_path__ + "static/img/showroom10.fc43e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom10.png
// module id = d7iA
// module chunks = 2